import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["competenceSection", "competencesList"]

  toggleCompetenceSection(event) {
    if (event.target.checked) {
      this.competenceSectionTarget.style.display = ''
    } else {
      this.competenceSectionTarget.style.display = 'none'
    }
  }

  // addCompetence(event) {
  //   event.preventDefault()
  //   const list = this.competencesListTarget
  //   const time = new Date().getTime()
  //   const regexp = new RegExp('new_competences', 'g')
  //   const template = this._buildCompetenceFields(time)
  //   list.insertAdjacentHTML('beforeend', template)
  // }

  removeCompetence(event) {
    event.preventDefault()
    const field = event.target.closest('.competence-fields')
    if (field) field.remove()
  }

  markForDestroy(event) {
    event.preventDefault()
    const field = event.target.closest('.competence-fields')
    const destroyInput = field.querySelector('input[name$="[_destroy]"]')
    destroyInput.value = '1'
    field.style.display = 'none'
  }

  _buildCompetenceFields(time) {
    return `
      <div class="flex gap-2 items-end mb-2 competence-fields" data-new-record="true">
        <div class="flex-1">
          <input type="text" name="course[competences_attributes][new_${time}][title]" required class="w-full rounded border-gray-300" placeholder="Titre" />
        </div>
        <div class="w-32">
          <input type="number" name="course[competences_attributes][new_${time}][scale]" required min="1" class="w-full rounded border-gray-300" placeholder="Barème" />
        </div>
        <div>
          <button type="button" class="text-red-600 ml-2" data-action="competence-form#removeCompetence">&times;</button>
        </div>
      </div>
    `
  }
} 